<style lang="less">
@import "./main.less";
</style>
<template>
  <div class="main" :class="{ 'main-hide-text': shrink }">
    <div
      class="sidebar-menu-con"
      ref="sidebar"
      @scroll="onScroll"
      :style="{
        width: shrink ? '60px' : '200px',
        overflow: shrink ? 'visible' : 'auto',
        backgroundColor: menuTheme === 'dark' ? '#495060' : '#fff',
        userSelect: 'none',
      }"
    >
      <div slot="top" class="logo-con">
        <img v-show="!shrink" src="../images/im-logo.png" key="max-logo" />
        <img v-show="shrink" src="../images/im-logo.png" key="min-logo" />
      </div>
    <!--  -->
    <!-- :active-text-color="menuTheme === 'dark' ? '#fff' : '#409EFF'" -->
      <el-menu
        :default-active="$route.path"
        :collapse="shrink"
        :background-color="menuTheme === 'dark' ? '#495060' : '#fff'"
        text-color="rgba(255,255,255,0.7)"
        @open="onOpenMenu"
        @close="onCloseMenu"
        :default-openeds="openeds"
      >
        <template v-for="(m, index) in menuList">
          <template v-if="m.isShow && m.code.indexOf('hide-') < 0 && m.hasChildMenu && m.children && m.children.length&&m.name!='Merchandise Management'">
            <el-submenu :index="m.code + 'm'" :key="index + 'm'">
              <template slot="title">
                <Icon class="menu-icon" :type="m.cssStyle || 'ios-list'"></Icon>
                <span slot="title">{{ m.name }}</span>
              </template>
              <template v-for="(sm, sindex) in m.children">
                <el-menu-item v-if="sm.isShow && sm.code.indexOf('hide-') < 0" :index="sm.urlAddr" :key="sindex + 'sm'" @click="jump(sm)">{{ sm.name }}</el-menu-item>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item v-if="m.isShow && m.code.indexOf('hide-') < 0 &&m.name!='Merchandise Management'" :index="m.urlAddr" :key="index + 'm'" @click="jump(m)">
              <Icon class="menu-icon" :type="m.cssStyle || 'ios-list'"></Icon>
              <span slot="title">{{ m.name }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
    <div
      class="main-header-con"
      :style="{ paddingLeft: shrink ? '60px' : '200px' }"
    >
      <div class="main-header">
        <div class="navicon-con">
          <Button
            :style="{
              transform: 'rotateZ(' + (this.shrink ? '-90' : '0') + 'deg)'
            }"
            type="text"
            @click="toggleClick"
          >
            <Icon type="navicon" size="32"></Icon>
          </Button>
        </div>
        <div class="header-middle-con">
          <div class="main-breadcrumb">
            <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
          </div>
        </div>
        <div class="header-avator-con">
          <div class="lang" @click="switchLang" v-if="$route.path.indexOf('/crm/') === 0">
            <span :class="{on: locale === 'zh-CN'}">中</span>/<span :class="{on: locale === 'en'}">EN</span>
          </div>
          <message-tip
            v-if="hasMsgPermission"
            :mesCount="mesCount"
          ></message-tip>

          <div class="user-dropdown-menu-con">
            <Row
              type="flex"
              justify="end"
              align="middle"
              class="user-dropdown-innercon"
            >
              <Dropdown
                transfer
                trigger="click"
                @on-click="handleClickUserDropdown"
              >
                <a href="javascript:void(0)">
                  <span class="main-user-name">{{ userName }}</span>
                  <Icon type="arrow-down-b"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="loginout" divided>Logout</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Avatar
                icon="person"
                style="background: #619fe7;margin-left: 10px;"
              />
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div class="single-page-con" :style="{ left: shrink ? '60px' : '197px' }">
      <div class="single-page">
        <router-view :shrink="shrink"></router-view>
      </div>
    </div>
    <Row class="loading" v-show="pageLoading">
      <Spin fix>
        <Icon type="load-c" size="20" class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </Row>
  </div>
</template>
<script>
import breadcrumbNav from "./main-components/breadcrumb-nav.vue";
import messageTip from "./main-components/message-tip.vue";
import util from "@/utils/util.js";
import { userInfo, getAuthMenu, checkTechnical } from "@/api/login";
import { gioSetUserId } from '@/utils/gio.js'
import { hasNoReadMessage } from "../api/message";
import i18n, { setLang } from '@/locale';
import _ from "lodash";
export default {
  components: {
    breadcrumbNav,
    messageTip
  },
  data() {
    const openMenusJson = localStorage.getItem('open-menus');
    let openNames = [];
    if (openMenusJson) {
      openNames = JSON.parse(openMenusJson);
      localStorage.removeItem('open-menus');
    }
    return {
      shrink: false,
      userName: "",
      openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
      hasMsgPermission: false,
      mesCount: false,
      menuList: [],
      locale: i18n.locale,
      openeds: openNames,
    };
  },
  computed: {
    showWhitch() {
      // this.shrink = !this.shrink;
    },
    pageLoading() {
      return this.$store.state.app.pageLoading;
    },
    pageTagsList() {
      return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
    },
    currentPath() {
      if (this.$route.meta && this.$route.meta.name) {
        
        const formData = JSON.parse( JSON.stringify(this.$route.query, ["id", "name","co"]));
        // console.log(formData);
        const path = this.$store.state.app.currentPath.map((item, index) => {
          return {  ...item, path: index == this.$store.state.app.currentPath.length - 2 
                  ? item.path + '?' + this.obj2Param(formData) : 
                  item.path
          }
        })
        return path
      }
      return this.$store.state.app.currentPath; // 当前面包屑数组
    },
    menuTheme() {
      return this.$store.state.app.menuTheme;
    }
  },
  methods: {
    onScroll() {
      this.saveSidebarScrollTop();
    },
    jump(menu) {
      if (this.$route.path !== menu.urlAddr) {
        this.$router.push({ path: menu.urlAddr });
      }
    },
    onOpenMenu(index) {
      const openeds = new Set(this.openeds);
      openeds.add(index);
      localStorage.setItem('open-menus', JSON.stringify([...openeds]))
    },
    onCloseMenu(index) {
      const openeds = new Set(this.openeds);
      openeds.delete(index);
      localStorage.setItem('open-menus', JSON.stringify([...openeds]))
    },
    obj2Param(obj) {
      var str = "";
      for (var key in obj) {
          if (str != "") {
              str += "&";
          }
          str += key + "=" + encodeURIComponent(obj[key]);
      }
      return str;
    },
    init() {
      Promise.all([userInfo(), checkTechnical({userId: null})]).then(res => {
          let useremal = "";
          if (res[0] && res[0].data && res[1] && res[1].data) {
            if (res[0].data.code === 1) {
              this.$store.commit("logout");
              return;
            }
            if (res[0].data.result && res[0].data.result.redisCacheUserDetails) {
              let redisCacheUserDetails = res[0].data.result.redisCacheUserDetails;
              this.$store.commit("setUserDetail", redisCacheUserDetails);
              this.$store.commit("setTechnical", res[1].data.result);
              this.userName = res[0].data.result.redisCacheUserDetails.name;
              gioSetUserId(res[0].data.result.redisCacheUserDetails.id);
              localStorage.setItem("userName", this.userName);
              localStorage.setItem("userId", res[0].data.result.redisCacheUserDetails.id);
              localStorage.setItem(
                "useremail",
                res[0].data.result.redisCacheUserDetails.emailAddr
              );
              useremal = res[0].data.result.redisCacheUserDetails.emailAddr;
            }
          }
          this.getAuthMenu(useremal);
        })
        .catch(() => {
          this.getAuthMenu();
        });
    },
    getAuthMenu(useremal) {
      let appIds = [10, 13, 12];
      if (process.env.VUE_APP_MIS_ENV === "dev") {
        appIds = [10, 13, 12,17,23,27];
      } else if (process.env.VUE_APP_MIS_ENV === "newtest") {
        appIds = [10, 13, 12,17,22,28];
      } else if (process.env.VUE_APP_MIS_ENV === "pre") {
        appIds = [10, 13, 12,17,22,28];
      } else if (process.env.VUE_APP_MIS_ENV === "prd") {
        appIds = [4, 7, 6,13,17,23];
      }
      getAuthMenu(appIds).then(res => {
        if (res.data && res.data.code === 1) {
          this.$notify({
            title: "警告",
            message: res.data.error,
            type: "warning",
            duration: 0
          });
          return;
        }
        const temp = [];
        res.data.result.forEach(app => {
          app.list.forEach(item => {
            if (item.code.indexOf("admin2-Boutique") !== 0) {
              temp.push(item);
            }
          });
        });
        // 两应用的 现货批发 合并
        for (let i = 0; i < temp.length; i++) {
          const menu = temp[i];
          if (menu.name === "现货批发") {
            for (let j = i + 1; j < temp.length; j++) {
              const menu2 = temp[j];
              if (menu2.name === "现货批发") {
                menu.children = menu.children.concat(menu2.children);
                temp.splice(j, 1);
              }
            }
          }
        }
        this.menuList = temp;
        const map = {};
        temp.forEach(item => {
          (item.children || []).forEach(item2 => {
            map[`${item.code}-${item2.code}`] = 1;
            (item2.children || []).forEach(item3 => {
              map[`${item.code}-${item2.code}-${item3.code}`] = 1;
              (item3.children || []).forEach(item4 => {
                map[`${item.code}-${item2.code}-${item3.code}-${item4.code}`] = 1;
              })
            })
          })
        })
        this.$store.commit("updateMenulist", this.menuList);
        this.$store.commit("setMenuMap", map);
        localStorage.setItem('menuList',JSON.stringify(this.menuList))
        if (this.menuList && this.menuList.length) {
          for (let i = 0; i < this.menuList.length; i++) {
            if (this.menuList[i].code === "消息按钮") {
              this.hasMsgPermission = true;
            }
          }
        }
      });
    },
    toggleClick() {
      this.shrink = !this.shrink;
    },
    handleClickUserDropdown(name) {
      if (name === "ownSpace") {
        util.openNewPage(this, "ownspace_index");
        this.$router.replace({
          name: "ownspace_index"
        });
      } else if (name === "loginout") {
        this.$store.commit("logout");
      }
    },
    switchLang() {
      this.locale = this.locale === 'en' ? 'zh-CN' : 'en';
      setLang(this.locale);
    },
  },
  watch: {
    $route(to) {
      // this.$store.commit('setCurrentPageName', to.name);
      let pathArr = util.setCurrentPath(this, to);
      this.$store.commit("setPageLoading", false);
      // if (pathArr.length > 2) {
      //     this.$store.commit('addOpenSubmenu', pathArr[1].name);
      // }
      // this.checkTag(to.name);
      // localStorage.currentPageName = to.name;
    }
  },
  created() {
    this.init();
  },
  mounted() {
    util.setCurrentPath(this, this.$route);
    this.saveSidebarScrollTop = _.debounce(() => {
      localStorage.setItem('sidebar-st', this.$refs.sidebar.scrollTop)
    }, 100);
    const sidebarScrollTop = localStorage.getItem('sidebar-st');
    if (sidebarScrollTop) {
      this.$refs.sidebar.scrollTop = sidebarScrollTop;
      // localStorage.removeItem('sidebar-st');
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.hasMsgPermission) {
        hasNoReadMessage()
          .then(res => {
            if (res.data && res.data.data && res.data.data.hasNoReadMessage) {
              vm.mesCount = true;
            } else {
              vm.mesCount = false;
            }
          })
          .catch(error => {
            vm.mesCount = false;
          });
      }
    });
  }
};
</script>
<style scoped lang="less">
.lang {
  display: flex;
  margin-right: 20px;
  padding: 0 5px;
  color: #666;
  font-size: 12px;
  line-height: 20px;
  border: 1px solid #DCDFE6;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;

  .on {
    color: #000;
    font-weight: bold;
  }
}
.menu-icon {
  color: rgba(255,255,255,0.7);
  margin-right: 10px;
}
</style>
